import * as React from 'react';
import CompanyListDataGrid from './CompanyListDataGrid';

function Screeners({data} :any) {
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item"><a href="/profile">Profile</a></li>`
            <li className="breadcrumb-item active" aria-current="page">Screener</li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{data.name}</h4>
              <p className="card-description"></p>
                <CompanyListDataGrid
                 data={data.data}
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Screeners;
